import emailjs from '@emailjs/browser';

// Environment configuration (ensure these exist in .env)
const SERVICE_ID = process.env.REACT_APP_serviceId;
const TEMPLATE_ID = process.env.REACT_APP_templateId;
const PUBLIC_KEY = process.env.REACT_APP_publicId;

function validateEnquiryData(data) {
    const errors = {};
    if (!data || typeof data !== 'object') errors.form = 'Invalid payload';
    const name = (data.from_name || '').trim();
    const contact = (data.contact || '').trim();
    const email = (data.email || '').trim();
    const city = (data.city || '').trim();
    const subject = (data.subject || '').trim();
    if (!name) errors.from_name = 'Name required';
    else if (name.length < 2) errors.from_name = 'Min 2 characters';
    else if (!/^[a-zA-Z\s]+$/.test(name)) errors.from_name = 'Letters & spaces only';
    if (!contact) errors.contact = 'Mobile required';
    else if (!/^[6-9]\d{9}$/.test(contact)) errors.contact = 'Invalid mobile';
    if (email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) errors.email = 'Invalid email';
    }
    if (!city) errors.city = 'City required';
    else if (city.length < 2) errors.city = 'Min 2 characters';
    else if (!/^[a-zA-Z\s]+$/.test(city)) errors.city = 'Letters & spaces only';
    if (!subject) errors.subject = 'Subject required';
    else if (subject.length < 3) errors.subject = 'Min 3 characters';
    return errors;
}

let _initialized = false;

function ensureConfig() {
    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
        const err = new Error('Email service configuration missing');
        err.type = 'config';
        err.missing = {
            SERVICE_ID: !SERVICE_ID,
            TEMPLATE_ID: !TEMPLATE_ID,
            PUBLIC_KEY: !PUBLIC_KEY
        };
        throw err;
    }
    if (!_initialized) {
        emailjs.init(PUBLIC_KEY);
        _initialized = true;
    }
}

// Object-based send (recommended when you manually map fields)
export default async function Emailjs(data) {
    console.log("SERVICE_ID, TEMPLATE_ID, PUBLIC_KEY:", SERVICE_ID, TEMPLATE_ID, PUBLIC_KEY);
    const errors = validateEnquiryData(data);
    if (Object.keys(errors).length) {
        const err = new Error('Validation failed');
        err.type = 'validation';
        err.errors = errors;
        throw err;
    }
    ensureConfig();
    const templateParams = {
        from_name: data.from_name,
        contact: data.contact,
        user_email: data.email || 'Not provided', // common template var
        city: data.city,
        product: data.product || data.sku || 'Not specified',
        subject: data.subject,
        message: data.message || 'No additional details'
    };
    Object.keys(templateParams).forEach(k => (templateParams[k] == null) && delete templateParams[k]);
    try {
        return await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams);
    } catch (e) {
        const status = e?.status || 0;
        const err = new Error('Email send failed');
        err.type = status === 400 ? 'bad-request' : 'network';
        err.status = status;
        err.original = e;
        err.payload = templateParams;
        throw err;
    }
}

// Form-based send (official docs style) - requires matching name attributes
export async function EmailjsForm(formRef) {
    ensureConfig();
    if (!formRef || !formRef.current) {
        const err = new Error('Form ref invalid');
        err.type = 'form-ref';
        throw err;
    }
    try {
        return await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, { publicKey: PUBLIC_KEY });
    } catch (e) {
        const status = e?.status || 0;
        const err = new Error('Email form send failed');
        err.type = status === 400 ? 'bad-request' : 'network';
        err.status = status;
        err.original = e;
        throw err;
    }
}

export { validateEnquiryData };